import { DataTableColumn } from './../../components/generics/data-table/data-table.component';
import { ServiceConfiguration } from '../../models/service.model';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

export interface ServicesSelectorDialogParams {
    available: ServiceConfiguration[];
    selected: ServiceConfiguration[];
}

@Component({
    selector: 'app-services-selector-dialog',
    templateUrl: './services-selector-dialog.component.html',
    styleUrls: ['./services-selector-dialog.component.scss']
})
export class ServicesSelectorDialogComponent implements OnInit {

    requiredServices: ServiceConfiguration[] = [];

    columns: DataTableColumn[] = [
        { name: 'Servicio', prop: 'servicio.nombre' },
        { name: 'Descripción', prop: 'servicio.descripcion' },
        { name: 'Tipo de cotización', prop: 'tipoCotizacion' },
        { name: 'Producto', prop: 'servicio.tipoProducto', type: 'text' },
        { name: 'Código', prop: 'servicio.codigo' },
    ];

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ServicesSelectorDialogParams
    ) { }

    ngOnInit() {
        // this.requiredServices = this.data.available.filter(service => service.servicio.codigo === 'ALQUILER' || service.servicio.codigo === 'EXPENSAS');
        this.onServiceSelect(this.data.selected);
    }

    cerrarDialogo(resultado: boolean) {
        if (!resultado) {
            this.dialogRef.close(resultado);
        } else {
            this.dialogRef.close(this.data.selected);
        }
    }

    onServiceSelect(selected: ServiceConfiguration[]) {
        setTimeout(() => {
            this.requiredServices.forEach(requiredService => {
                if (!this.data.selected.find(service => service === requiredService)) {
                    this.data.selected.push(requiredService);
                }
            });
        });
    }

    rowId = (row: ServiceConfiguration) => row.id ?? `${row.servicio.id}-${row.tipoCotizacion}`;
}
